import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { extend } from 'jquery';
import { filter } from 'lodash';

// INNER IMPORTS
import {convertArrayOfObjectsToCSV, getCurrency} from '../../../../utils';
import { getAllTransactions } from '../../../../Actions/admin';

import { SimpleDatePicker } from '../../../Elements/Pickers';
import FaErrowDown from 'react-icons/lib/fa/angle-down';
import FaErrowUp from 'react-icons/lib/fa/angle-up';

// styling
import '../mainAdminstyles.css';


class Transactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            type: "liveMusic",
            userEmail: '',
            startDate: '',
            endDate: ''
        };
    }

    componentDidMount() {
        this.props.getAllTransactions(this.props.token);
    }

    downloadCSV() {
        let data, filename, link;

        const transactions = extend(true, {}, this.props.transactions);

        // using lodash to prevent pass to 'transactions' a value and not a reference for the array AND the objects in it
        const filteredTrans = filter(transactions, (tran) => {
            if (!tran.email) return;

            return this.state.userEmail ? tran.email.includes(this.state.userEmail) : true;
        });

        const transactionsData = filteredTrans.map((tran)=> {
            return {
                'Email': tran.email || '',
                'First Name': tran.customerFirstName || '',
                'Last Name': tran.customerLastName || '',
                'Payment Day': tran.saleTime ? moment(tran.saleTime).format('DD.MM.YY') : '',
                'First Payment Day': tran.firstSaleTime ? moment(tran.firstSaleTime).format('DD.MM.YY') : '',
                'Type': tran.type || '',
                'Main Category': tran.category || '',
                'Package': tran.enrollType || '',
                'Price': `${getCurrency(tran.transactionCurrency)}${tran.transactionAmount}`
            }
        });

        let csv = convertArrayOfObjectsToCSV({ data: transactionsData });

        if (csv === null) return;

        filename = 'transactions.csv';

        const csvFinal = 'data:text/csv;charset=utf-8,' + csv.replace('data:text/csv;', '');

        // if (!csv.match(/^data:text\/csv/i)) {
        //     csv = 'data:text/csv;charset=utf-8,' + csv;
        // }

        data = encodeURI(csvFinal);

        link = document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('download', filename);
        link.click();
    }


    setUserEmail(event){
        if (!event) return;
        this.setState({userEmail: event.target.value});
    }

    dateHandler(startDate, endDate) {
        this.setState({
            startDate,
            endDate
        });

        // this.setState({transactions: [...this.props.transactions]});
    }

    // searchTempUsers() {
    //     this.props.getAllTransactions(this.props.token, this.state.startDate, this.state.endDate, true);
    // }

    handleResetDatesClick() {
        this.setState({startDate: '', endDate: '', sortType: ''});
    }

    handleSearchClick() {
        this.props.getAllTransactions(this.props.token, this.state);
    }

    sortByEmail() {
        if (this.state.sortEmail) {
            this.props.transactions.sort((a, b) => {
                if (a.email > b.email) return 1;
                if (a.email < b.email) return -1;

                return 0;
            });
        } else {
            this.props.transactions.sort((a, b) => {
                if (a.email < b.email) return 1;
                if (a.email > b.email) return -1;

                return 0;
            });
        }

        this.setState({sortEmail: !this.state.sortEmail, users: this.props.transactions, sortType: 'email'});
    }

    sortByText() {

    }

    sort() {
        if (this.state.sortEntrance) {
            this.props.transactions.sort((a, b) => a.loginCount - b.loginCount);
        } else {
            this.props.transactions.sort((a, b) => b.loginCount - a.loginCount);
        }

        this.setState({sortEntrance: !this.state.sortEntrance, transactions: this.props.transactions, sortType: 'entrance'});
    }

    getDateRanges() {
        return {
            'Today': [moment().startOf('day'), moment().endOf('day')],
            'This Month': [moment().startOf('month'), moment().startOf('day')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().startOf('month')],
            'Last 7 Days': [moment().subtract(7, 'days'), moment().startOf('day')],
            // 'This Month': [moment().startOf('day'), moment().endOf('day')]
            'Last 30 Days': [moment().startOf('day').subtract(30, 'days'), moment().startOf('day')]

        }
    }

    renderTransactions() {
        if (!this.props.transactions) return null;

        // const transactionsByEmail = this.props.transactions.filter((trans) => {
        //     if (!trans.email) return;
        //
        //     return this.state.userEmail ? trans.email.includes(this.state.userEmail) : true;
        // });

        return this.props.transactions.map((trans) => {
            return (
                <tr key={trans._id}>
                    <td className="name">
                        {trans.email}
                    </td>
                    <td className="name">
                        {trans.customerFirstName}
                    </td>

                    <td className="name">
                        {trans.customerLastName}
                    </td>

                    <td className="name">
                        {moment(trans.saleTime).format('DD.MM.YY')}
                    </td>
                    <td className="name">
                        {trans.firstSaleTime ? moment(trans.firstSaleTime).format('DD.MM.YY') : ''}
                    </td>
                    <td className="name">
                        {trans.type}
                    </td>
                    <td className="name">
                        {trans.category}
                    </td>
                    <td className="name">
                        {trans.enrollType}
                    </td>
                    <td className="name">
                        {getCurrency(trans.transactionCurrency)}{trans.transactionAmount}
                    </td>
                    <td className="name">
                        {trans.receiptLink ? <a href={trans.receiptLink} target="_blank" rel="noopener noreferrer">link</a> : null}
                    </td>
                </tr>
            )
        })
    }


    renderArrow(direction) {
        if (direction) return <i><FaErrowUp /></i>;
        return <i><FaErrowDown /></i>
    }

    render() {
        return (
            <div className="admin-wrapper">
                <div className="content">
                    <div className="top-bar">
                        <div className="title">Users</div>
                    </div>
                    <div className="inner-nav">
                        <div className="inner-nav-row">
                            <SimpleDatePicker
                                datePickHandler={(startDate, endDate) => this.dateHandler(startDate, endDate)}
                                label="By Last Payment"
                                minDate={moment().subtract(5, 'years').toISOString()}
                                maxDate={moment()}
                                ranges={this.getDateRanges()}
                            />

                            {this.state.startDate && this.state.endDate ?
                                <div className="selected-dates">
                                    <span>{moment(this.state.startDate).format('DD.MM.YY')} - {moment(this.state.endDate).format('DD.MM.YY')}</span>
                                </div> : null
                            }

                            <div className="users-btn" onClick={() => this.handleResetDatesClick()}>Reset Dates</div>
                            <input
                                type="text"
                                name="user-search"
                                onChange={(event) => this.setUserEmail(event)}
                                placeholder="Search by email"
                            />
                            <div className="users-btn" onClick={()=> this.handleSearchClick()}>Search</div>

                            <div className="users-btn push-right" onClick={ ()=> this.downloadCSV() }>Export</div>
                        </div>
                    </div>

                    <div className="table-wrapper">
                        <div className="table-scroll">
                            {this.props.isMorePages
                                ? <p className="results-label">More results available - narrow search</p>
                                : <p className="results-label">{this.props.transactions ? this.props.transactions.length : 'No'} results</p>
                            }
                            <table>
                                <thead>
                                <tr>
                                    <th onClick={() => this.sortByEmail()}>
                                        <span className="text">Email</span>
                                        {this.state.sortType === 'email' ? this.renderArrow(this.state.sortEmail) : null}
                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">First Name</span>
                                        {this.state.sortType === 'firstName' ? this.renderArrow(this.state.sortByText) : null}
                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">Last Name</span>
                                        {this.state.sortType === 'lastName' ? this.renderArrow(this.state.sortByText) : null}
                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">Payment Date</span>
                                        {this.state.sortType === 'paymentDate' ? this.renderArrow(this.state.sortLastLogin) : null}

                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">First Payment Date</span>
                                        {this.state.sortType === 'firstPaymentDate' ? this.renderArrow(this.state.sortFreePins) : null}

                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">Type</span>
                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">Category</span>
                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">Package</span>
                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">Amount</span>
                                        {this.state.sortType === 'amount' ? this.renderArrow(this.state.sortPushPins) : null}

                                    </th>
                                    <th onClick={() => {}}>
                                        <span className="text">Invoice Link</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.renderTransactions()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Transactions.propTypes = {
    transactions: PropTypes.array,
    token: PropTypes.string,
    getAllTransactions: PropTypes.func,
    deactivate: PropTypes.func,
    activate: PropTypes.func,
    createTempUserCall: PropTypes.func,
    beUser: PropTypes.func,
    isMorePages: PropTypes.bool
};

const mapStateToProps = (state) => ({
    token: state.users.token,
    transactions: state.admin && state.admin.transactions || [],
    isMorePages: state.admin && state.admin.isMorePages
});

export default connect(mapStateToProps, {
    getAllTransactions
})(Transactions);



// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/Transactions/Transactions.js